export default __webpack_public_path__ + "static/media/icn_logo_v2.3ae64c26.svg";